import actions from './actions';
import mutations from './mutations';
import state from './state';

export default {
  name: 'productGroups',
  namespaced: true,
  actions,
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/product-groups/store/index.js